import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Login from './components/login';
import Register from './components/Register';
import Datos from './components/datos';
import Header from './components/Header';
import ProduccionMaquina from './components/graficas/produccion-maquina';
import ProduccionRama from './components/graficas/produccion-rama';
import AmperajesMaquina from './components/graficas/amperajes-maquina';
import AmperajeMaquinaDia from './components/graficas/amperaje-maquina-dia';
import FormularioMaquina from './components/formularioMaquina';
import Home from './components/home'; // Importar el componente Home
import MaquinasTable from './components/MaquinasTable';
import TablaRPM from './components/TablaRPM';
import UltimoAcumuladoRPMPage from './components/UltimoAcumuladoRPMPage';
import ParametrosMaquinas from './components/ParametrosMaquinas';
import FormOperarioTurno from './components/asignarOperarios';
import FormReferenciaMaquina from './components/asignarReferencia';
import AsignarTenido from './components/AsignarTenido';
import CalendarioMantenimiento from './components/CalendarioMantenimiento';
import TablaTenido from './components/TablaTenido';
import OperatorForm from './components/OperatorForm';
import ReferenciaForm from './components/ReferenciaForm';
import MateriaPrimaForm from './components/MateriaPrimaForm';
import TablaUltimoAcumuladoOperario from './components/TablaUltimoAcumuladoOperario';
import ParametrosTurnos from './components/ParametrosTurnos';
import FormularioGuardarTurnos from './components/FormularioGuardarTurnos';
import EficienciaTable from './components/EficienciaTable';
import ProduccionPorReferencia from './components/ProduccionPorReferencia';
import MaquinaDiaPage from './components/MaquinaDiaPage';
import ValoresEficiencia from './components/ValoresEficiencia';
import AcumuladoMachine8Grafica from './components/AcumuladoMachine8Grafica';
import GraficaProduccionReferencia from './components/graficas/GraficaProduccionReferencia';
import ProgramaTelas from './components/ProgramaTelas';
import GestionContactosAlarma from './components/GestionContactosAlarma';
import ProgramacionIA from './components/ProgramacionIA';
import AgenteTurnos from './components/AgenteTurnos';
import CaracteristicasMaquinas from './components/CaracteristicasMaquinas';
import ClasificacionMaquinas from './components/ClasificacionMaquinas';
import CambioAgujas from './components/CambioAgujas';
import { AdminRoute, ProtectedRoute } from './components/ProtectedRoute';
import GestionUsuarios from './components/GestionUsuarios';
import OtaFirmware from './components/OtaFirmware';
import PronosticoTiempo from './components/PronosticoTiempo';
import MapaSeguimiento from './components/MapaSeguimiento';
import CreacionCargo from './components/CreacionCargo';
import ReglasProgramacion from './components/ReglasProgramacion';
import ConfiguracionAgente from './components/ConfiguracionAgente';
import AusenciasOperario from './components/AusenciasOperario';
import TablaHorasOperario from './components/TablaHorasOperario';
import Prueba from './components/Prueba';
import CatalogoTablas from './components/CatalogoTablas';
import EnergiaShelly from './components/EnergiaShelly';
// ...

const App = () => {
    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}>
            <Router>
                <div style={{ marginTop: '80px'}}>
                    <Header />
                    <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<AdminRoute><Register /></AdminRoute>} />
                    <Route path="/datos" element={<ProtectedRoute><Datos /></ProtectedRoute>} />
                    <Route path="/" element={<Home />} />
                    <Route path="/formulario-maquina" element={<AdminRoute><FormularioMaquina /></AdminRoute>} />
                    <Route path="/maquinas/parametros/ingreso" element={<AdminRoute><FormularioMaquina /></AdminRoute>} />
                    <Route path="/tabla-promedio-rpm" element={<ProtectedRoute><TablaRPM /></ProtectedRoute>} />
                    <Route path="/ultimo-acumulado-rpm" element={<ProtectedRoute><UltimoAcumuladoRPMPage /></ProtectedRoute>} />
                    <Route path="/MaquinasTable" element={<ProtectedRoute><MaquinasTable /></ProtectedRoute>} />
                    <Route path="/maquinas/parametros" element={<AdminRoute><ParametrosMaquinas /></AdminRoute>} />
                    <Route path="/maquinas/parametros/caracteristicas" element={<AdminRoute><CaracteristicasMaquinas /></AdminRoute>} />
                    <Route path="/maquinas/parametros/cambio-agujas" element={<AdminRoute><CambioAgujas /></AdminRoute>} />
                    <Route path="/maquinas/parametros/tipos" element={<AdminRoute><ClasificacionMaquinas /></AdminRoute>} />
                    <Route path="/maquinas/mantenimiento" element={<AdminRoute><CalendarioMantenimiento /></AdminRoute>} />
                    <Route path="/maquinas/valores-eficiencia" element={<AdminRoute><ValoresEficiencia /></AdminRoute>} />
                    <Route path="/maquinas/contactos-alarma" element={<AdminRoute><GestionContactosAlarma /></AdminRoute>} />
                    <Route path="/maquinas/asignar-operarios" element={<AdminRoute><FormOperarioTurno /></AdminRoute>} />
                    <Route path="/maquinas/asignar-referencia" element={<AdminRoute><FormReferenciaMaquina /></AdminRoute>} />
                    <Route path="/maquinas/asignar-tenido" element={<AdminRoute><AsignarTenido /></AdminRoute>} />
                    <Route path="/tablas/tabla-tenido" element={<AdminRoute><TablaTenido /></AdminRoute>} />
                    <Route path="/maquinas/ingreso-operario" element={<AdminRoute><OperatorForm /></AdminRoute>} />
                    <Route path="/maquinas/referencias" element={<AdminRoute><ReferenciaForm /></AdminRoute>} />
                    <Route path="/maquinas/parametros/ingreso-materia-prima" element={<AdminRoute><MateriaPrimaForm /></AdminRoute>} />
                    <Route path="/ultimo-acumulado-operarios" element={<ProtectedRoute><TablaUltimoAcumuladoOperario /></ProtectedRoute>} />
                    <Route path="/maquinas/parametros-turnos" element={<ProtectedRoute><ParametrosTurnos /></ProtectedRoute>} />
                    <Route path="/maquinas/formulario-guardar-turnos" element={<AdminRoute><FormularioGuardarTurnos /></AdminRoute>} />
                    <Route path="/tabla-promedio-rpm/eficiencia-table" element={<ProtectedRoute><EficienciaTable /></ProtectedRoute>} />                
                    <Route path="/graficas/produccion-maquina" element={<ProtectedRoute><ProduccionMaquina /></ProtectedRoute>} />
                    <Route path="/graficas/produccion-rama" element={<ProtectedRoute><ProduccionRama /></ProtectedRoute>} />
                    <Route path="/graficas/amperajes-maquina" element={<ProtectedRoute><AmperajesMaquina /></ProtectedRoute>} />
                    <Route path="/graficas/amperaje-maquina-dia" element={<ProtectedRoute><AmperajeMaquinaDia /></ProtectedRoute>} />
                    <Route path="/graficas/maquina-dia" element={<ProtectedRoute><MaquinaDiaPage /></ProtectedRoute>} />
                    <Route path="/graficas/acumulado-machine8" element={<ProtectedRoute><AcumuladoMachine8Grafica /></ProtectedRoute>} />
                    <Route path="/graficas/produccion-referencia" element={<ProtectedRoute><GraficaProduccionReferencia /></ProtectedRoute>} />
                    <Route path="/produccion-por-referencia" element={<ProtectedRoute><ProduccionPorReferencia /></ProtectedRoute>} />
                    <Route path="/programa-telas" element={<ProtectedRoute><ProgramaTelas /></ProtectedRoute>} />
                    <Route path="/ia/programacion" element={<AdminRoute><ProgramacionIA /></AdminRoute>} />
                    <Route path="/ia/agente-turnos" element={<AdminRoute><AgenteTurnos /></AdminRoute>} />
                    <Route path="/admin/usuarios" element={<AdminRoute><GestionUsuarios /></AdminRoute>} />
                    <Route path="/admin/ota" element={<AdminRoute><OtaFirmware /></AdminRoute>} />
                    <Route path="/clima" element={<ProtectedRoute><PronosticoTiempo /></ProtectedRoute>} />
                    <Route path="/energia" element={<ProtectedRoute><EnergiaShelly /></ProtectedRoute>} />
                    <Route path="/mapa-seguimiento" element={<ProtectedRoute><MapaSeguimiento /></ProtectedRoute>} />
                    <Route path="/maquinas/parametros/cargos" element={<AdminRoute><CreacionCargo /></AdminRoute>} />
                    <Route path="/maquinas/parametros/reglas-programacion" element={<AdminRoute><ReglasProgramacion /></AdminRoute>} />
                    <Route path="/maquinas/parametros/configuracion-agente" element={<AdminRoute><ConfiguracionAgente /></AdminRoute>} />
                    <Route path="/maquinas/parametros/ausencias-operario" element={<AdminRoute><AusenciasOperario /></AdminRoute>} />
                    <Route path="/tablas/horas-operario" element={<ProtectedRoute><TablaHorasOperario /></ProtectedRoute>} />
                    <Route path="/graficas/prueba" element={<ProtectedRoute><Prueba /></ProtectedRoute>} />
                    <Route path="/tablas/catalogo" element={<ProtectedRoute><CatalogoTablas /></ProtectedRoute>} />
                </Routes>
            </div>
        </Router>
        </GoogleOAuthProvider>
    );
};

export default App;